import { useContext, useState, useEffect } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AppLink, AppSpan, AppText, CustomContainer, FlexColumn, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { BiCamera } from "react-icons/bi"
import { RiUserSmileLine } from "react-icons/ri"
import UserChatIcon from 'src/assets/img/support/user-chat-icon.svg'

export const ChatLayout: React.FC = () => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {userInfo: {profileInfo}}} = useContext(UserContext)
    const [chatHeight, setChatHeight] = useState('')
    const [ebanqoUrl, setEbanqoUrl] = useState('')

    useEffect(() => {
        let width1150 = window.matchMedia('(max-width: 1150px)').matches
        let width900 = window.matchMedia('(max-width: 900px)').matches
        let width600 = window.matchMedia('(max-width: 600px)').matches

        let height = width1150 ? '92.5%' : width900 ? '93.5%' : width600 ? '94%' : '100%'
        setChatHeight(height)
    }, [window])

    useEffect(() => {
        handleGetEbanqoUrl()
    }, [])

    async function handleGetEbanqoUrl () {
        const response = await API.getEbanqoSupport()
        setEbanqoUrl(response)
    }

    return (
        <>
            <CustomContainer >
                <ScreenTitle textSize="2.2" fontWeight="700">Chats</ScreenTitle>
            </CustomContainer>
            { ebanqoUrl === null ?
                <CustomContainer
                    bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                    shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                    padding='2' topPadding='1' bottomPadding='1'
                    topMargin='2.5'
                >
                    <AppText color='#0A756F' fontWeight="600">Service unavailable</AppText>
                    <AppSpan textSize='1.2' color='#0A756F'>
                        This service is currently unavailable, kindly reach out to customer support.
                    </AppSpan>
                </CustomContainer>
                :
                <CustomContainer 
                    maxHeight="100" mxHUnit="%" overflow="auto"
                    topMargin="2" bottomPadding="2.5" //bottomPadding="8.5"
                    width="100" sizeUnit="%"
                    height="100" hUnit="%"
                    className="chat-content"
                >
                    <iframe 
                        //src={`https://webchat.ebanqo.io/${institutionData?.alias}/?fullname=Internet%20Banking&email=${profileInfo?.emailAddress}&form_id=email&source=appchat&os=android`}
                        src={ebanqoUrl}
                        width='100%' height={chatHeight}
                        style={{border: 'none'}}
                    />
                </CustomContainer>
            }
            {/* <AbsoluteContainer bottom="0" right="0" width="100" sizeUnit="%">
                <GridContainer 
                    height="8.4" leftPadding="2" rightPadding="2" bgColor="#ffffff"
                    shadow="0px -1px 1px rgba(0, 0, 0, 0.1)"
                >
                    <FlexRow>
                        <BiCamera style={{marginRight: '1rem', fontSize: '2.2rem'}}/>
                        <CustomContainer
                            className="chat-input-container"
                            radius="2.4" bgColor="#F5F5F5" height="4.2"
                            rightPadding="3.5"
                        >
                            <Input
                                leftPadding="1.5" height="4.2" textSize="1.4"
                                placeholder="Write a comment"
                            />
                            <AbsoluteContainer top="1" right="1">
                                <RiUserSmileLine style={{fontSize: '2rem'}} />
                            </AbsoluteContainer>
                        </CustomContainer>
                    </FlexRow>
                </GridContainer>
            </AbsoluteContainer> */}
        </>
    )
} 